module.exports = __webpack_public_path__ + "images/newimage.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/newimage.png
// module id = 134
// module chunks = 0